import axios from "axios"

// const baseUrl = "https://millenium-orthodontics.onrender.com"
// Production on Vercel serves the API and /images from the same origin, so
// the base URL is empty (relative). Set REACT_APP_BASE_URL to override.
export const baseUrl = process.env.REACT_APP_BASE_URL
    ?? (process.env.NODE_ENV === "production" ? "" : "http://localhost:8000")
// const baseUrl = "http://localhost:8000"

// -----------------auth---------------------------------------
// Signup is request-otp -> verify-otp (see below); there is no direct
// "/signup" endpoint since account creation requires OTP verification.

export const login = async (values) => {
    const data = await axios.post(`${baseUrl}/api/user/login`, { email: values.email, password: values.password })
    return data
}
// -----------------products------------------------------------
export const getAllProducts = async () => {
    const products = await axios.get(`${baseUrl}/api/product/all`)
    return products.data.data
}

// Paginated product fetch for the category catalog page. Optionally scoped
// to a category; mirrors the backend's page/limit query params and returns
// the full {success, data, currentPage, totalProducts, totalPages} payload.
export const getProductsPage = async ({ category, page = 1, limit = 24 } = {}) => {
    const params = { page, limit }
    if (category) params.category = category
    const response = await axios.get(`${baseUrl}/api/product/all`, { params })
    return response.data
}

// -------------------cart--------------------------------------
export const getCart = async (config) => {
    const products = await axios.get(`${baseUrl}/api/cart/all`, config)
    return products
}

export const addingToCart = async (id, config) => {
    const response = await axios.post(`${baseUrl}/api/cart/add`, { itemid: id }, config)
    return response
}

export const removingFromCart = async (id, config) => {
    const response = await axios.post(`${baseUrl}/api/cart/remove`, { itemid: id }, config)
    return response
}

// ---------------------------place-order----------------------------------

export const placeorder = async (orderData, config) => {
    const response = await axios.post(`${baseUrl}/api/order/place-order`, orderData, config)
    return response
}

// ---------------------------categories----------------------------------

export const categoryWiseProducts = async (param) => {
    const response = await axios.get(`${baseUrl}/api/category/${param}`)
    return response
}

// -----------------------------search------------------------------------

export const searchAll = async (searchQuery) => {
    const response = await axios.get(`${baseUrl}/api/search/all`, { params: { productName: searchQuery } })
    return response
}

export const searchCategoryWise = async (searchQuery, category) => {
    const response = await axios.get(`${baseUrl}/api/search/category`, { params: { productName: searchQuery, category: category } })
    return response
}

export const requestOtp = async ({ name, email, password }) => {
    const response = await axios.post(`${baseUrl}/api/user/request-otp`, { name, email, password });
    return response
}

export const requestPasswordReset = async (email) => {
    const response = await axios.post(`${baseUrl}/api/user/request-password-reset`, { email });
    return response
}

export const verifyOtp = async (data) => {
    const response = await axios.post(`${baseUrl}/api/user/verify-otp`, data);
    return response
}

export const verifyResetOtp = async (data) => {
    const response = await axios.post(`${baseUrl}/api/user/verify-reset-otp`, data);
    return response
}

export const resetPassword = async (data) => {
    const response = await axios.post(`${baseUrl}/api/user/reset-pass`, data);
    return response
}

